import React from 'react'
import { Grid, Button } from '@material-ui/core'
import ChartTempoStatus from './ChartTempoStatus'
import ChartTempoAnalise from './ChartTempoAnalise'
import { useHistory } from 'react-router-dom'

function PainelDetalhesSolicitacao(props) {
  const history = useHistory()

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <ChartTempoStatus {...props} />
      </Grid>
      <Grid item xs={12}>
        <ChartTempoAnalise {...props} />
      </Grid>
      <div
        style={{
          display: 'flex',
          justifyContent: 'flex-end',
          width: '100%',
          marginRight: 5
        }}
      >
        <Button
          variant="contained"
          color="primary"
          style={{ width: 160 }}
          onClick={() => history.goBack()}
        >
          Voltar
        </Button>
      </div>
    </Grid>
  )
}

export default PainelDetalhesSolicitacao
